<template>
  <div>
    <div v-if="hasLog">
      <section-title title="Historial del Libro" has-line class="mt-4" />
      <div v-for="(item, idx) in logItems" :key="idx">
        <timeline-item :date="item.createdDate" :key="idx">
          <div class="row w-100" :class="{ 'mb-3': hasTransferLog(item) }">
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Estatus:
              </label>
              <custom-balloon
                :background-color="item.equipmentStatusColor"
                :text="item.equipmentStatusName"
                dot
              />
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Tipo de Localidad:
              </label>
              <p>{{ item.locationName | empty }}</p>
            </div>
            <div v-if="!item.isCSEEType" class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                {{ item | determineType }}
              </label>
              <p>
                {{ item | determineName }}
              </p>
            </div>
            <div class="col-12 col-lg-3">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Nombre del Estudiante:
              </label>
              <p>{{ item.referral | empty }}</p>
            </div>
            <div
              v-if="hasTransferLog(item)"
              class="col-12 border-bottom mx-2"
            ></div>
          </div>
          <div v-if="item.transferLog">
            <div class="row w-100">
              <div class="col-12 col-lg-2">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Estatus de la Solicitud:
                </label>
                <custom-balloon
                  :background-color="item.transferLog.statusColor"
                  :text="item.transferLog.statusName"
                  dot
                />
              </div>
              <div class="col-12 col-lg-3">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Número de Solicitud:
                </label>
                <p>{{ item.transferLog.requestCode | empty }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Centro a Transferir:
                </label>
                <p>{{ item.transferLog.caatTo | empty }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Fecha de Solicitud:
                </label>
                <p>{{ item.transferLog.requestDate | date }}</p>
              </div>
              <div class="col-12 col-lg-3">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Sometido por:
                </label>
                <p>{{ item.transferLog.requestBy | empty }}</p>
              </div>
            </div>
            <div class="row w-100">
              <div class="col-12 col-lg-2">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Fecha de Envío:
                </label>
                <p>{{ item.transferLog.sendDate | date }}</p>
              </div>
              <div class="col-12 col-lg-3">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Asignado a:
                </label>
                <p>{{ item.transferLog.assigned | empty }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Fecha de Transferencia:
                </label>
                <p>{{ item.transferLog.transferDate | date }}</p>
              </div>
              <div class="col-12 col-lg-2">
                <label
                  class="color-secondary-6 font-14 font-weight-normal mr-2"
                >
                  Comentario:
                </label>
                <p>{{ item.transferLog.comment | empty }}</p>
              </div>
            </div>
          </div>
        </timeline-item>
      </div>
      <div class="row my-4">
        <div class="col text-center">
          <action-button
            v-if="showMore"
            variant="outline-success custom-view-more actionButton"
            i="fas fa-chevron-down"
            @click="handlerMore"
          >
            Ver más
          </action-button>
        </div>
      </div>
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
  </div>
</template>

<script>
import CustomResultNotFound from "custom-result-not-found";
import ActionButton from "ActionButton";
import TimelineItem from "@quisit/timeline-item";
import CustomBalloon from "custom-balloon";
import SectionTitle from "@/components/common/page/SectionTitle.vue";
import LocationTypes from "@/utils/constants/inventory/inventoryOrderBookLocationTypes";
import inventoryService from "@/services/api/inventorycatalog.api";

export default {
  name: "BookHistory",
  components: {
    TimelineItem,
    CustomResultNotFound,
    ActionButton,
    CustomBalloon,
    SectionTitle
  },
  props: {
    book: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    determineType: function(value) {
      if (!value) return "-";
      return value.bookLocationTypeId == LocationTypes.CENTER.id
        ? "Centro:"
        : "Escuela:";
    },
    determineName: function(value) {
      if (!value) return "-";
      return value.bookLocationTypeId == LocationTypes.CENTER.id
        ? value.equipmentCaat
        : value.school;
    }
  },
  data() {
    return {
      history: [],
      logCount: 5,
      locationTypes: [
        LocationTypes.CSEE,
        LocationTypes.CENTER,
        LocationTypes.SCHOOL
      ]
    };
  },
  computed: {
    bookId() {
      return Number(this.$route.params.bookId);
    },
    logItems() {
      const items = this.history
        .map(item => {
          return {
            ...item,
            date: item.requestDate
          };
        })
        .slice(0, this.logCount);
      return items;
    },
    hasLog() {
      return this.history.length > 0;
    },
    hasTransferLog() {
      return item => item.transferLog !== null;
    },
    showMore() {
      return this.history.length > this.logCount && this.history.length > 5;
    }
  },
  mounted() {
    this.getHistory();
  },
  methods: {
    async getHistory() {
      try {
        const response = await inventoryService.getBookTransferHistory(
          this.bookId
        );

        this.history = response.data.map(item => {
          const location = this.locationTypes.find(
            l => l.id == item.bookLocationTypeId
          );
          return {
            ...item,
            locationName: location ? location.name : null,
          };
        });
      } catch {}
    },
    handlerMore() {
      this.logCount += 5;
    }
  }
};
</script>

<style></style>
